module.exports = __webpack_public_path__ + "img/ALFALogoQBP - Lite.d2afbac9.png";